(function() {

	$( window ).on( 'load', function() {

		const noticeLength = $( '.notice-inner' ).length;
		let counter = 0;

		const rotateBanner = setInterval(() => {

			if( counter == ( noticeLength - 1 ) ) {

				$( '.cycled' ).each( function() {

					$( this ).removeClass( 'cycled' ).addClass( 'reset' );

				});

				$( '.reset' ).each( function() {

					$( this ).removeClass( 'reset' ).addClass( 'inactive' );

				});

				$( '.notice-inner.active' ).addClass( 'transitioning' );

				setTimeout( function() {

					$( $( '.notice-inner.inactive' )[ 0 ] ).removeClass( 'inactive' ).addClass( 'active' );

				}, 250 );

				$( '.notice-inner.transitioning' ).addClass( 'cycled' ).removeClass( 'transitioning' ).removeClass( 'active' );

				$( '.notice-inner.cycled' ).removeClass( 'cycled' ).addClass( 'reset' );

				$( '.notice-inner.reset' ).removeClass( 'reset' ).addClass( 'inactive' );

				counter = 0;

			} else {

				$( '.notice-inner.active' ).addClass( 'transitioning' );

				$( $( '.notice-inner.inactive' )[ 0 ] ).removeClass( 'inactive' ).addClass( 'active' );

				setTimeout( function() {

					$( '.notice-inner.transitioning' ).addClass( 'cycled' ).removeClass( 'transitioning' ).removeClass( 'active' );

					counter = counter + 1;

				}, 250 );

			}

		}, 5000 );

	});

})();
